import React from 'react';

// Header Component - Extracted from App.js for better maintainability
// Displays app title, exam info, personal message, and domain icons

const Header = ({ domains }) => {
  return (
    <>
      {/* Header */}
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          CompTIA Security+ Certification Exam Objectives
        </h1>
        <p className="text-lg text-gray-600 mb-1">EXAM NUMBER: SY0-701</p>
        <div className="flex justify-center space-x-2 mt-4">
          {[...Array(5)].map((_, i) => (
            <div key={i} className={`w-12 h-12 ${domains[i].color} rounded flex items-center justify-center text-white`}>
              <span className="material-icons text-sm">
                {i === 0 ? '🔒' : i === 1 ? '⚠️' : i === 2 ? '🏗️' : i === 3 ? '⚙️' : '📋'}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Personal Message - moved under header */}
      <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-6 rounded-r">
        <div className="text-gray-700 text-sm leading-relaxed">
          <p className="mb-2">
            <strong>Hi my name is Will,</strong> I made this app to help you study and hopefully pass the CompTIA Security+ exam. 
            Please always refer to the <a href="https://partners.comptia.org/certifications/security" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">official CompTIA website</a> for any changes in the exam or objectives, 
            and also please print a copy of the official exam objective from the CompTIA website. 
            This app has no affiliations with CompTIA.
          </p>
          <p>
            If you have any issues with the app, you can email me at <a href="mailto:will_automate@icloud.com" className="text-blue-600 hover:underline">will_automate@icloud.com</a> 
            or send a message to the WhatsApp support group 
            <a 
              href="https://chat.whatsapp.com/L7qni5s3b1KJhGpIYacZVZ?mode=ems_email_t" 
              className="inline-flex items-center ml-1 px-2 py-1 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors text-xs" 
              target="_blank" 
              rel="noopener noreferrer"
              title="Join WhatsApp Support Group"
            >
              📱 WhatsApp
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default React.memo(Header);